(() => {
  const copy = document.getElementById('star-express-copy');
  const main = document.getElementById('MainContent');
  if (!copy || !main) return;
  let scheduled = false;
  const apply = () => {
    scheduled = false;
    const app = main.querySelector('.radix-themes');
    if (!app) return;
    for (const node of app.querySelectorAll('div, li, p')) {
      if (node.children.length) continue;
      const text = node.textContent.trim();
      if (text === 'Express options available at checkout' || text === 'Express options available') {
        node.textContent = copy.dataset.message;
        node.classList.remove('md:text-nowrap');
      } else if (text === 'Choose your delivery speed at checkout') {
        node.textContent = copy.dataset.checkout;
      }
    }
    for (const title of app.querySelectorAll('h3')) {
      if (!title.textContent.trim().startsWith('PLUS | Digital delivery + Physical gift set')) continue;
      const container = title.parentElement;
      if (container.querySelector('[data-star-express-plus]')) continue;
      const note = document.createElement('p');
      note.dataset.starExpressPlus = 'true';
      note.className = 'text-sm text-start ml-3 mt-2';
      note.style.cssText = 'color:inherit;line-height:1.5';
      note.textContent = `${copy.dataset.message}. ${copy.dataset.checkout}`;
      container.append(note);
    }
  };
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(apply);
  }).observe(main, {childList: true, subtree: true});
  apply();
})();
